module.exports = __webpack_public_path__ + "static/media/2.a2bad2e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/2.jpg
// module id = 97
// module chunks = 0